import { Component } from '@angular/core';

@Component({
  selector: 'app-cards1-examples-2',
  templateUrl: './cards1-examples-2.component.html'
})
export class Cards1Examples2Component {}
